import React from "react";
import { Download } from "lucide-react";
import { Card, Kpi, Field, SelectInput, Table } from "@/components/ExcelUI";
import { kgf, sum } from "@/lib/excelCalc";

export default function BehoefteTab({ btn, exportCSV, behoefteYear, setBehoefteYear, behoefteWeek, setBehoefteWeek, activeYears, WEEKS, behoefteRows }) {
  return (
    <>
      <div className="flex items-start justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight text-slate-900 mb-1">Grondstofbehoefte</h1>
          <p className="text-sm text-slate-500">Benodigde grondstoffen &amp; hulpstoffen per week/jaar op basis van de ingevoerde productie. Voorraad wordt in het externe systeem beheerd.</p>
        </div>
        <button className={btn} data-testid="behoefte-export" onClick={() => exportCSV(`grondstofbehoefte-${behoefteYear}-w${behoefteWeek}.csv`,
          ["Grondstof/hulpstof", "Behoefte kg"], behoefteRows.map((b) => [b.naam, b.behoefte.toFixed(1)]))}>
          <Download className="h-4 w-4 mr-2 inline" />Export
        </button>
      </div>
      <Card className="mb-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 items-end">
          <Field label="Jaar"><SelectInput testid="behoefte-year" value={behoefteYear} onChange={setBehoefteYear} options={activeYears.map(String)} /></Field>
          <Field label="Week (0 = hele jaar)"><SelectInput testid="behoefte-week" value={behoefteWeek} onChange={setBehoefteWeek} options={["0", ...WEEKS.map(String)]} /></Field>
          <Kpi label="Materialen" value={behoefteRows.length} />
          <Kpi label="Totaal benodigd" value={kgf(sum(behoefteRows, (b) => b.behoefte))} />
        </div>
      </Card>
      <Table testid="behoefte-row" columns={["Grondstof / hulpstof", "Behoefte kg"]}
        rows={behoefteRows.map((b) => [b.naam, kgf(b.behoefte)])} />
    </>
  );
}
